import React, { useEffect } from "react";
import {Link} from "react-router-dom";
import "./ProCards.css";
import GitHubIcon from "@mui/icons-material/GitHub";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const ProCards = (props) => {
  useEffect(() => {
    const card = document.getElementById("proCard_"+props.id);
    // console.log(card)
    const cardAbout1 = document.getElementById("cardAbout1_" + props.id);
    const cardAbout2 = document.getElementById("cardAbout2_" + props.id);
    card.addEventListener("mouseover", () => {
      cardAbout1.style.animation = "cardAboutAni 2s 1 forwards";

    });
    card.addEventListener("mouseover", () => {
      cardAbout2.style.animation = "cardAboutAni 2s 1s 1 forwards";

    });
    card.addEventListener("mouseout", () => {
      cardAbout1.style.animation = "";
      cardAbout1.style.opacity = "0%";
    });
    card.addEventListener("mouseout", () => {
      cardAbout2.style.animation = "";
      cardAbout2.style.opacity = "0%";
    });
  }, []);
  return (
    <>
      <div id={props.id} className="cardOuter">
        <div id={"cardAbout1_" + props.id} className="cardAbout">
          <div>{props.about1}</div>
        </div>
        <div className="proCard" id={"proCard_"+props.id} style={{ backgroundColor: props.color }}>
          <div className="proImage">
            <img src={props.src} alt="" />
          </div>
          <div className="proCardText">{props.text}</div>
          <div className="proHeader">
            <Link to={props.gitLink}  target="__blank"><GitHubIcon style={{ scale: "1.1", cursor: "pointer" }} /></Link>
            <Link to={props.liveLink} target="__blank"><OpenInNewIcon style={{ scale: "1.1", cursor: "pointer" }} /></Link>
          </div>
        </div>
        <div id={"cardAbout2_" + props.id} className="cardAbout">
          {props.about2}
        </div>
      </div>
    </>
  );
};

export default ProCards;
